import { useState } from 'react';

import { Button } from '../../cdl/Button/Button';
import { Input } from '../../cdl/Input/Input';
import { Text } from '../../cdl/Text/Text';
import { useToasts } from '../../cdl/Toast/useToasts';
import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';
import { useMariAppsLinkPurchaseOrder } from '../useMariAppsLinkPurchaseOrder';

import { IntegrationOfferSelect, IntegrationOfferSelectOption } from './IntegrationOfferSelect';

export const LinkPurchaseOrderSection = () => {
    const [state, setState] = useState({
        orderId: '',
        offerId: '',
        poNumber: '',
    });
    const linkPurchaseOrderMutation = useMariAppsLinkPurchaseOrder();
    const { addToast, addErrorToast } = useToasts();

    const trimmedPoNumber = state.poNumber.trim();
    const isSubmitDisabled = !state.offerId || !state.orderId || !trimmedPoNumber;

    const handleOfferChange = (option: IntegrationOfferSelectOption) => {
        setState((currentState) => ({
            ...currentState,
            offerId: option.value,
            orderId: option.offer.orderId || '',
        }));
    };

    const handlePoNumberChange = (poNumber: string) => {
        setState((currentState) => ({
            ...currentState,
            poNumber,
        }));
    };

    const handleSubmit = () => {
        if (!state.offerId || !state.orderId || !trimmedPoNumber) {
            return;
        }

        linkPurchaseOrderMutation.mutate(
            {
                orderId: state.orderId,
                offerId: state.offerId,
                poNumber: trimmedPoNumber,
            },
            {
                onSuccess: (response) => {
                    addToast(response.message);
                },
                onError: (error) => {
                    const backendMessage = error.response?.data?.error;
                    addErrorToast(backendMessage || translate('integrationsOverview.linkPurchaseOrderUnknownError'));
                },
            }
        );
    };

    return (
        <Box display="flex" gap={8} flexDirection="column" alignItems="flex-start">
            <Text variant="title" as="h2">
                {translate('integrationsOverview.linkPurchaseOrderTitle')}
            </Text>
            <Text variant="small" color="foreground.subtle">
                {translate('integrationsOverview.linkPurchaseOrderDescription')}
            </Text>

            <Box width="100%" display="flex" flexDirection="column" gap={8}>
                <IntegrationOfferSelect
                    label={translate('integrationsOverview.linkPurchaseOrderOfferLabel')}
                    value={state.offerId}
                    onChange={handleOfferChange}
                />

                <Input
                    label={translate('integrationsOverview.linkPurchaseOrderPoNumberLabel')}
                    value={state.poNumber}
                    onChange={(event) => handlePoNumberChange(event.target.value)}
                />
            </Box>

            <Button disabled={isSubmitDisabled} isLoading={linkPurchaseOrderMutation.isPending} onClick={handleSubmit}>
                {translate('integrationsOverview.linkPurchaseOrderButton')}
            </Button>
        </Box>
    );
};
